var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { InputWrapper, VisuallyHidden, Input } from "../..";
import { getInputWrapperLss } from '../inputRowWrapperStyling';
import { AddRemoveInputButton } from './AddRemoveInputButton';
export var GroupInputRow = function (_a) {
    var inputRef = _a.inputRef, name = _a.name, id = _a.id, rowIcons = _a.rowIcons, _b = _a.isTouched, isTouched = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, isInvalid = _a.isInvalid, error = _a.error, _d = _a.inputIndex, inputIndex = _d === void 0 ? 0 : _d, _e = _a.inputRowsCount, inputRowsCount = _e === void 0 ? 1 : _e, onAddInput = _a.onAddInput, onRemoveInput = _a.onRemoveInput, _f = _a.allowDeleteSingleRow, allowDeleteSingleRow = _f === void 0 ? false : _f, props = __rest(_a, ["inputRef", "name", "id", "rowIcons", "isTouched", "disabled", "isInvalid", "error", "inputIndex", "inputRowsCount", "onAddInput", "onRemoveInput", "allowDeleteSingleRow"]);
    var _g = __read(useState(false), 2), isFocused = _g[0], setFocused = _g[1];
    var errorLabel = error ? (React.createElement(VisuallyHidden, { id: id }, error)) : null;
    var showRemoveIcon = allowDeleteSingleRow || inputRowsCount > 1;
    var removeIcon = showRemoveIcon && typeof onRemoveInput === 'function' ? (React.createElement(AddRemoveInputButton, { as: "remove", onClick: onRemoveInput, id: id || "remove-item-" + inputIndex })) : null;
    var addIcon = typeof onAddInput === 'function' ? (React.createElement(AddRemoveInputButton, { as: "add", onClick: onAddInput, id: id || "add-item-" + inputIndex })) : null;
    return (React.createElement(InputWrapper, { disabled: disabled, isInvalid: isInvalid, isTouched: isTouched, isFocused: isFocused, onFocus: function () { return setFocused(true); }, onBlur: function () { return setFocused(false); }, lss: getInputWrapperLss({
            inputIndex: inputIndex,
            inputRowsCount: inputRowsCount,
            isFocused: isFocused,
            isInvalid: isInvalid
        }) },
        errorLabel,
        rowIcons,
        React.createElement(Input, __assign({}, props, { id: id, name: name, "aria-invalid": isInvalid ? 'true' : 'false', "aria-describedby": isInvalid ? name + ".error" : undefined, ref: inputRef, onKeyDown: function (ev) {
                if (ev.key === 'Enter' && typeof onAddInput === 'function') {
                    ev.preventDefault();
                    onAddInput();
                }
            } })),
        removeIcon,
        addIcon));
};
//# sourceMappingURL=GroupInputRow.js.map